<template>
  <div>
    <template v-if="!quickData.length">
      <ul class="pz_one">
        <li>
          <input
            v-model="keyword"
            type="text"
            class="txt"
            placeholder="请输入查询条件"
          />
          <button class="getYzm" @click="getCode">扫描</button>
        </li>
        <li>
          <button :disabled="searchLoading" class="btn" @click="search">
            搜索<br />
            <span>Search</span>
          </button>
        </li>
        <li class="tishi" style="text-align: center">
          <div>
            请输入注册手机号码、证件号码或点击右侧“扫描”按钮识别二维码。
          </div>
        </li>
        <div id="interactive" class="viewport"></div>
      </ul>
    </template>
    <template v-else>
      <ul class="pz_two">
        <li
          v-for="(page, index) in pagedData"
          :key="index"
          @click="getDetail(page)"
        >
          <p class="type">{{ page.certificateName }}</p>
          <p>{{ page.company }}</p>
          <p>{{ page.name }}</p>
          <p>{{ page.title }}</p>
        </li>
      </ul>
      <div class="page" v-if="quickData.length > 1">
        <span @click="prevPage">上一页</span>
        <div class="fan" @click="back">返回</div>
        <span @click="nextPage">下一页</span>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      quickData: [],
      searchLoading: false,
      keyword: "",
      timer: undefined,
      count: 60,
      currentPage: 0, // 当前页码
      itemsPerPage: 3, // 每页显示的元素数量
    };
  },
  beforeMount() {},
  mounted() {
    if (this.scannedCode) {
      this.keyword = this.scannedCode;
      this.clearScannedCode();
      this.search();
    }
  },
  computed: {
    ...mapState("scanStore", ["scannedCode"]),
    pagedData() {
      // 使用computed计算属性来获取分页后的数据
      const start = this.currentPage * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.quickData.slice(start, end);
    },
  },
  methods: {
    ...mapMutations("scanStore", ["clearScannedCode"]),
    // 上一页
    prevPage() {
      if (this.currentPage > 0) {
        this.currentPage -= 1;
      }
    },
    // 下一页
    nextPage() {
      if (this.currentPage < this.retrieveData.length / this.itemsPerPage) {
        this.currentPage += 1;
      }
    },
    // 返回
    back() {
      this.retrieveData = [];
    },
    getCode() {
      this.clearScannedCode();
      this.$router.push({ path: "/scan" });
    },
    search() {
      if (!this.keyword) {
        this.$message.warning("请输入查询条件");
        return;
      }
      this.searchLoading = true;
      const { alias } = this.$route.query;
      this.$get(
        `/api/Quick/PreciseSearch?alias=${alias}&keyword=${this.keyword}`
      )
        .then((res) => {
          if (!res.data.length) {
            this.$message.warning("数据不存在");
            return;
          }
          if (res.data.length === 1) {
            this.getDetail(res.data[0]);
            return;
          }
          this.quickData = [...res.data];
        })
        .finally(() => {
          this.searchLoading = false;
        });
    },
    getDetail(item) {
      const { alias } = this.$route.query;
      this.$router.push({
        path: "/quick-service/manage",
        query: {
          alias,
          rid: item.id,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.switch {
  width: 100%;
  padding: 10px 30px;
  display: flex;
  justify-content: flex-end;
}
#interactive.viewport {
  canvas,
  video {
    float: left;
    width: 640px;
    height: 480px;
  }
  canvas.drawingBuffer,
  video.drawingBuffer {
    margin-left: -640px;
  }
}

.btn-container {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.btn-container i {
  display: inline-block;
  position: relative;
  top: -9px;
}

label {
  font-size: 13px;
  color: #424242;
  font-weight: 500;
}

.btn-color-mode-switch {
  display: inline-block;
  margin: 0px;
  position: relative;
}

.btn-color-mode-switch > label.btn-color-mode-switch-inner {
  margin: 0px;
  width: 140px;
  height: 30px;
  background: #e0e0e0;
  border-radius: 26px;
  overflow: hidden;
  position: relative;
  transition: all 0.3s ease;
  /*box-shadow: 0px 0px 8px 0px rgba(17, 17, 17, 0.34) inset;*/
  display: block;
}

.btn-color-mode-switch > label.btn-color-mode-switch-inner:before {
  content: attr(data-on);
  position: absolute;
  font-size: 12px;
  font-weight: 500;
  top: 7px;
  right: 20px;
}

.btn-color-mode-switch > label.btn-color-mode-switch-inner:after {
  content: attr(data-off);
  width: 70px;
  height: 26px;
  background: #fff;
  border-radius: 26px;
  position: absolute;
  left: 2px;
  top: 2px;
  text-align: center;
  transition: all 0.3s ease;
  box-shadow: 0px 0px 6px -2px #fff;
  padding: 5px 0px;
}

.btn-color-mode-switch > .alert {
  display: none;
  background: #ff9800;
  border: none;
  color: #fff;
}

.btn-color-mode-switch input[type="checkbox"] {
  cursor: pointer;
  width: 50px;
  height: 25px;
  opacity: 0;
  position: absolute;
  top: 0;
  z-index: 1;
  margin: 0px;
}

.btn-color-mode-switch
  input[type="checkbox"]:checked
  + label.btn-color-mode-switch-inner:after {
  content: attr(data-on);
  left: 68px;
  background: #fff;
}

.btn-color-mode-switch
  input[type="checkbox"]:checked
  + label.btn-color-mode-switch-inner:before {
  content: attr(data-off);
  right: auto;
  left: 20px;
}

.btn-color-mode-switch input[type="checkbox"]:checked ~ .alert {
  display: block;
}

.white-preview {
  background: #fff;
}
</style>
